import styled from 'styled-components';

export const ContentWithFooterContainer = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;

  width: 100%;
  max-width: var(--default-breakpoint-width);
  margin-inline: auto;
`;

export const ContentWithFooterContent = styled.div`
  display: flex;
  flex-direction: column;

  flex: 1;
`;

export const ContentWithFooterFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  padding: 8px 16px;

  // All contents must take full width
  > * {
    width: 100%;
  }
`;
